import React from "react";
const Instructions = ()=>{
        return (<div className="section">
            <h2 className="title is-2">Instructions </h2>
            <div className="card">
                <header className="card-header has-background-dark">
                    <h3 className="card-header-title is-size-4 has-text-white">COURSE LIST</h3>
                </header>
                <div className="card-content">
                    <div className="content">
                        <strong>Subject</strong>
                        <br /> Select the Subject for which you would like to see Courses.
                        <div className="content">
                            <ul >
                                <li><strong>All Subjects</strong><br />Show all subjects.</li>
                                <li><strong>Only subjects that meet 92NAC</strong>
                                    <br />
                                    These courses apply in meeting 92NAC 10-004.04B (high school instructional offerings) and are included in the calculation of properly endorsed instructional units/FTEs in accordance with 92NAC 10.004.04A, 10-007.02A, 10-007.03A and 92NAC 14-005.02A, 14-006-02A and 14-007-02A.
                                </li>
                                <li><strong>Only subjects that DO NOT meet 92NAC</strong>
                                    <br />The following courses DO NOT apply in meeting 92NAC 10-004.04B (high school instructional offerings). With the exception of Special Education, these courses are included in the calculation of properly endorsed instructional units/FTEs in accordance with 92NAC 10.004.04A, 10-007.02A, 10-007.03A and 92NAC 14-005.02A, 14-006-02A and 14-007-02A.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="content">
                        <strong>List Format</strong>
                        <br /> Select the format to display the courses for the Subject area you have selected.
                        <div className="content">
                            <ul >
                                <li><strong>Expanded</strong>
                                    <br />
                                    View of Course Title, Short name, Course Code, Description and Clearing Endorsements
                                </li>
                                <li><strong>Compact</strong>
                                    <br />List view of Course Name, Short Name and Course Code
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="content">
                        <strong>Year</strong>
                        <br /> Select the year to view.
                    </div>
                    <div className="content">
                        <strong>Name</strong>
                        <br /> Show courses that contain the full or partial text entered.
                    </div>
                    <div className="content">
                        <strong>Course Code</strong>
                        <br /> Show courses that contain the full or partial course code entered.
                    </div>
                    <div className="content">
                        <strong>Endorsement</strong>
                        <br /> Show courses that contain the input endorsement code.
                    </div>
                    <div className="content">
                        <strong>Clear</strong>
                        <br /> Clear filter options.
                    </div>
                    <div className="content">
                        <strong>Download</strong>
                        <br /> Download the information from your selection.  Excel download will be provided.
                    </div>
                </div>
            </div>
                <br />
            <div className="card">
                <header className="card-header has-background-dark">
                    <h3 className="card-header-title is-size-4 has-text-white">INFORMATION</h3>
                </header>
                <div className="card-content">
                    <div className="content">
                        <ul>
                            <li>General Information</li>
                            <li>Certificate/Endorsement Level</li>
                            <li>Middle Grades</li>
                            <li>Secondary Grades</li>
                            <li>Elementary Grades</li>
                        </ul>
                    </div>
                </div>
            </div>
                <br />
            <div className="card">
                <header className="card-header has-background-dark">
                    <h3 className="card-header-title is-size-4 has-text-white">CHANGES</h3>
                </header>
                <div className="card-content">
                    <div className="content">
                        Change Summary
                    </div>
                </div>
            </div>
                <br />
            <div className="card">
                <header className="card-header has-background-dark">
                    <h3 className="card-header-title is-size-4 has-text-white">INSTRUCTIONS</h3>
                </header>
                <div className="card-content">
                    <div className="content">
                        Instruction Page.
                </div>
            </div>
        </div>
    </div>
    )};

export default Instructions;
